/**
 * STAND-IN for Maritime `Switch` — not in @syia-ai/maritimeai-ui 0.2.0.
 * Delete this file and import it from Maritime once it ships.
 *
 * An on/off control that acts immediately (a Checkbox is for choices submitted later).
 * `label` is the full accessible name; `children` is the short visible text beside it.
 */

import type { ReactNode } from 'react';

export interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: string;
  children?: ReactNode;
  disabled?: boolean;
}

export function Switch({ checked, onCheckedChange, label, children, disabled }: SwitchProps) {
  return (
    <span className="shell-switch">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        className="shell-switch__track"
        onClick={() => onCheckedChange(!checked)}
      >
        <span className="shell-switch__thumb" />
      </button>
      {children && (
        <span className="shell-switch__text" aria-hidden>
          {children}
        </span>
      )}
    </span>
  );
}
